/**
 * @description Port of Shopify `getSizedImageUrl` utility
 */
export const getSizedImageUrlPreloaded = (
  url: string,
  width: number,
  height: number,
  options: {
    crop?: string
    format?: string
    domain?: string
  } = {}
): string => {
  if (!url) return ''

  const {
    crop = 'center',
    format = 'pjpg',
    domain = window.location.hostname,
  } = options

  const [base, query] = url.split('?')
  const vMatch = query?.match(/v=(\d+)/)
  const version = vMatch ? vMatch[1] : undefined

  const cleanedBase = base
  .replace(/^https?:\/\//, '')
  .replace(/cdn\.shopify\.com\/s\/files(?:\/\d+)+\/files/, `${domain}/cdn/shop/files`)
  .replace('cdn.shopify.com', `${domain}/cdn/shop`)
  .replace(`${domain}/s/files`, `${domain}/cdn/shop/files`)

const searchParams = new URLSearchParams()
if (crop) searchParams.set('crop', crop)
if (format) searchParams.set('format', format)
if (typeof height === 'number') searchParams.set('height', height.toString())
if (typeof width === 'number') searchParams.set('width', width.toString())
if (version) searchParams.set('v', version)

  return `//${cleanedBase}?${searchParams.toString()}`
}
